export default {
	title: "Meeting Transcript",
	speakerLabel: "Speaker",
};
